export enum CompanyStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  PreActivated = 'PRE_ACTIVATED',
}
